import { Column } from './types';
import { cn } from '@/lib/utils';

interface TableProps<T> {
    data: T[];
    columns: Column<T>[];
    className?: string;
}

export function Table<T>({ data, columns, className }: TableProps<T>) {
    return (
        <div className={cn("w-full overflow-auto", className)}>
            <table className="w-full">
                <thead className="bg-slate-50 border-b">
                <tr>
                    {columns.map((column) => (
                        <th
                            key={column.key}
                            className="text-left p-4 font-medium text-sm whitespace-nowrap"
                        >
                            {column.header}
                        </th>
                    ))}
                </tr>
                </thead>
                <tbody>
                {data.map((item, rowIndex) => (
                    <tr key={rowIndex} className="border-b last:border-0">
                        {columns.map((column) => (
                            <td key={column.key} className="p-4">
                                {column.cell(item)}
                            </td>
                        ))}
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
}
